
import { Component,ChangeDetectorRef, OnInit, ViewChild } from '@angular/core';
import { NgForm, NgModelGroup } from '@angular/forms';
import { Router, ActivatedRoute} from '@angular/router';
import { Location } from '@angular/common';
import { SystemFunctionsService as Sys } from 'src/app/system-functions.service';
import { ValidatorService } from 'src/app/core/validator.service';
import { CanComponentDeactivate } from 'src/app/core/can-deactivate-guard.service';
import { debounceTime, Subject, Subscription } from "rxjs";
import { UtilityService } from 'src/app/utility.service';
import { ApplicationContextService } from 'src/app/application-context.service';
import { ApiService } from 'src/app/api.service';
import { APIResponseHandlerService } from 'src/app/api-response-handler.service';
import { AppInjector } from 'src/app/app-injector.module';
import { AppConstants } from 'src/app/app-constants';
import { LiquidService } from "src/app/liquid-service/liquid.service";

import {MedicineDetail,PrescriptionModel,HttpResponseMessage,PatientInfo,MedicalInfo,EnrollmentModel,MasterData} from 'src/app/models/models';




 import $ from 'jquery';
  
@Component({
  selector: 'ads-container-oncologyform',
  templateUrl: './oncologyform.component.html'
})
export class OncologyFormComponent implements OnInit, CanComponentDeactivate 
{
  public EnrollmentDetails=new EnrollmentModel();
public OralPrescriptionDetails=new PrescriptionModel();
public InjectablePrescriptionDetails=new PrescriptionModel();
public OralMedicineTypes:MasterData[]=[];
public InjectableMedicineTypes:MasterData[]=[];
public DrugsDetails=new PrescriptionModel();
public DrugTypes:MasterData[]=[];
public OralMedicineDetails=new MedicineDetail();
public ShowOralMedicine:boolean=false;
public ShowInjectableMedicine:boolean=false;
public InjectableMedicineDetails=new MedicineDetail();
public ShowSupportMedicine:boolean=false;
public SupportMedicineDetails=new MedicineDetail();
public SelectedState:string=null;
public InvalidAddressClass:string=null;
@ViewChild("Popupfd34f0e74b0342628a0d9fa1daf70710")
 public Popupfd34f0e74b0342628a0d9fa1daf70710: NgModelGroup;filterData_Dropdown7fb5de65e19349e6b7aa6248802b294d: any[];
filterData_Dropdownc7a1de4e924547149377aa62454fbd93: any[];public ddr_source_Dropdownc7a1de4e924547149377aa62454fbd93 = [{'text':'ML','value':'ML' }];









@ViewChild("Popup7259ec79297b449481ebaf68c831eb1c")
 public Popup7259ec79297b449481ebaf68c831eb1c: NgModelGroup;filterData_Dropdown1c7fd37cb89645b7b412bceac590ecd1: any[];
filterData_Dropdown4da4074be7b043a4837195a201e40a6c: any[];public ddr_source_Dropdown4da4074be7b043a4837195a201e40a6c = [{'text':'MG','value':'MG' },{'text':'ML','value':'ML' }];









@ViewChild("Popup0d13ff2c3cec4a3e877da382b7e7e0d2")
 public Popup0d13ff2c3cec4a3e877da382b7e7e0d2: NgModelGroup;filterData_Dropdowne4aeca920868477497d6603c6380d275: any[];
filterData_Dropdownaa3cec81d9da423fbb5669087b46d2d0: any[];public ddr_source_Dropdownaa3cec81d9da423fbb5669087b46d2d0 = [{'text':'MG','value':'MG' },{'text':'ML','value':'ML' }];




















filterData_Dropdownefdef215c651495aa08fc3be8951646b: any[];public ddr_source_Dropdownefdef215c651495aa08fc3be8951646b = [{'text':'Male','value':'Male' },{'text':'Female','value':'Female' }];












filterData_Dropdownc9f931b340e64fb8a166c91d9fb9ed46: any[];public ddr_source_Dropdownc9f931b340e64fb8a166c91d9fb9ed46 = [{'text':'Disease Progression','value':'Disease Progression' },{'text':'Finished Therapy','value':'Finished Therapy' },{'text':'Toxicity:','value':'Toxicity:' }];








































  public Sys = Sys;
  public AppConstants=AppConstants;
  public subscriptions:Subscription[]=[];
  public debounceObs = new Subject<Function>();
  validationMessages : string[] = [];
  public intervalIds : number[] = [];
  subscription: Subscription = new Subscription();
   canDeactivate(): boolean {
    return !this.OncologyFormForm.dirty;
  }
  @ViewChild('OncologyFormForm') OncologyFormForm: NgForm;

      @ViewChild("OralMedicineInfoGroup") public OralMedicineInfoGroup: NgModelGroup;
   
     @ViewChild("InjectableMedicineInfoGroup") public InjectableMedicineInfoGroup: NgModelGroup;
   
     @ViewChild("SupportMedicineInfoGroup") public SupportMedicineInfoGroup: NgModelGroup;
   
     @ViewChild("PatientInfoGroup") public PatientInfoGroup: NgModelGroup;
   
   
  constructor(private router: Router,
              private route: ActivatedRoute, 
              public vs: ValidatorService,
              public us: UtilityService,
              public appContext: ApplicationContextService,
              public apiServc: ApiService,
              private cdr: ChangeDetectorRef,
              public liquidService:LiquidService,
              public apiResponse:APIResponseHandlerService,
              private location: Location,
                            
              
                                            ){       
	this.subscriptions.push(this.debounceObs.pipe(debounceTime(350)).subscribe(fn => fn()));
  }  
    AddInjectableMedicineDetails(event:any) { if (this.InjectablePrescriptionDetails.MedicineDetails==null) { this.InjectablePrescriptionDetails.MedicineDetails = []; }this.ShowInjectableMedicine=true;this.us.ClearGroupsDirty([this.InjectableMedicineInfoGroup.control]);this.InjectableMedicineDetails = new MedicineDetail();this.InjectableMedicineDetails.Dosage="ML";; }
AddOralMedicineDetails(event:any) { if (this.OralPrescriptionDetails.MedicineDetails==null) { this.OralPrescriptionDetails.MedicineDetails = []; }this.ShowOralMedicine=true;this.us.ClearGroupsDirty([this.OralMedicineInfoGroup.control]);this.OralMedicineDetails = new MedicineDetail(); }
AddressChange(event:any) { let AddressComponent:any={};let AddressComponents:any[]=[];this.InvalidAddressClass="";if (event.address_components!=undefined) { AddressComponents=event.address_components;for (AddressComponent of AddressComponents){ if (AddressComponent.types[0]=="administrative_area_level_1") { this.SelectedState=AddressComponent.long_name; } } } }
AddSupportMedicineDetails(event:any) { if (this.DrugsDetails.MedicineDetails==null) { this.DrugsDetails.MedicineDetails = []; }this.ShowSupportMedicine=true;this.us.ClearGroupsDirty([this.SupportMedicineInfoGroup.control]);this.SupportMedicineDetails = new MedicineDetail(); }
DeleteInjectableMedicineDetails(CurrentItem:string = '',event:any) { let MedicineInfo=new MedicineDetail();let Index:number = -1;if (this.InjectablePrescriptionDetails.MedicineDetails!=null) { for (MedicineInfo of this.InjectablePrescriptionDetails.MedicineDetails){ Index=Index+1;if (MedicineInfo.Medicine==CurrentItem) { Sys.RemoveItemByIndex<MedicineDetail>(this.InjectablePrescriptionDetails.MedicineDetails, Index);break; } } } }
DeleteOralMedicineDetails(CurrentMedicine:string = '',event:any) { let MedicineInfo=new MedicineDetail();let index:number = -1;if (this.OralPrescriptionDetails.MedicineDetails!=null) { for (MedicineInfo of this.OralPrescriptionDetails.MedicineDetails){ index=index+1;if (MedicineInfo.Medicine==CurrentMedicine) { Sys.RemoveItemByIndex<MedicineDetail>(this.OralPrescriptionDetails.MedicineDetails, index);break; } } } }
DeleteSupportMedicineDetails(CurrentMedicine:string = '',event:any) { let MedicineInfo=new MedicineDetail();let Index:number = -1;if (this.DrugsDetails.MedicineDetails!=null) { for (MedicineInfo of this.DrugsDetails.MedicineDetails){ Index=Index+1;if (MedicineInfo.Medicine==CurrentMedicine) { Sys.RemoveItemByIndex<MedicineDetail>(this.DrugsDetails.MedicineDetails, Index);break; } } } }
async ngOnInit(){
	try{
		let PrescriptionDetails=new PrescriptionModel();  let EnrollmentDetailsActivityResponse=new HttpResponseMessage();let OralOncolyticsActivityResponse=new HttpResponseMessage();let InjectibleOncolyticsActivityResponse=new HttpResponseMessage();let SupportDrugsActivityResponse=new HttpResponseMessage(); this.EnrollmentDetails.PatientInfo = new PatientInfo();this.EnrollmentDetails.MedicalInfo = new MedicalInfo();this.EnrollmentDetails.Prescriptions = [];this.OralPrescriptionDetails.Type="ORAL ONCOLYTICS";
this.InjectablePrescriptionDetails.Type="INJECTABLE ONCOLYTICS";
this.DrugsDetails.Type="SUPPORT DRUGS";;let OralOncolyticsActivity=this.apiResponse.handle(<any>this.apiServc.GetMasterDataByType('masterdata'+`?type=${"ORAL ONCOLYTICS"}`,{},''));let InjectibleOncolyticsActivity=this.apiResponse.handle(<any>this.apiServc.GetMasterDataByType('masterdata'+`?type=${"INJECTABLE ONCOLYTICS"}`,{},''));let SupportDrugsActivity=this.apiResponse.handle(<any>this.apiServc.GetMasterDataByType('masterdata'+`?type=${"SUPPORT DRUGS"}`,{},''));OralOncolyticsActivityResponse=await OralOncolyticsActivity;
InjectibleOncolyticsActivityResponse=await InjectibleOncolyticsActivity;
SupportDrugsActivityResponse=await SupportDrugsActivity;;if (OralOncolyticsActivityResponse.StatusCode==200) { this.OralMedicineTypes=OralOncolyticsActivityResponse.Content; }if (InjectibleOncolyticsActivityResponse.StatusCode==200) { this.InjectableMedicineTypes=InjectibleOncolyticsActivityResponse.Content; }if (SupportDrugsActivityResponse.StatusCode==200) { this.DrugTypes=SupportDrugsActivityResponse.Content; }if (Sys.GetQueryString("id") != undefined && Sys.GetQueryString("id") != "") { let EnrollmentDetailsActivity= this.apiResponse.handle(<any>this.apiServc.GetEnrollmentDetails('enrollments/'+Sys.GetQueryString("id"),{},''));EnrollmentDetailsActivityResponse=await EnrollmentDetailsActivity;if (EnrollmentDetailsActivityResponse.StatusCode==200) { this.EnrollmentDetails=EnrollmentDetailsActivityResponse.Content;if (this.EnrollmentDetails.Prescriptions!=null) { this.OralPrescriptionDetails=this.us.Find(this.EnrollmentDetails.Prescriptions,PrescriptionDetails=>PrescriptionDetails.Type=="ORAL ONCOLYTICS");this.InjectablePrescriptionDetails=this.us.Find(this.EnrollmentDetails.Prescriptions,PrescriptionDetails=>PrescriptionDetails.Type=="INJECTABLE ONCOLYTICS");this.DrugsDetails=this.us.Find(this.EnrollmentDetails.Prescriptions,PrescriptionDetails=>PrescriptionDetails.Type=="SUPPORT DRUGS"); }if (this.OralPrescriptionDetails==undefined) { this.OralPrescriptionDetails = new PrescriptionModel();PrescriptionDetails.MedicineDetails = []; }if (this.InjectablePrescriptionDetails==undefined) { this.InjectablePrescriptionDetails = new PrescriptionModel();this.InjectablePrescriptionDetails.MedicineDetails = []; }if (this.DrugsDetails==undefined) { this.DrugsDetails = new PrescriptionModel();this.DrugsDetails.MedicineDetails = []; } } }else{ this.EnrollmentDetails.PatientInfo = new PatientInfo();this.EnrollmentDetails.MedicalInfo = new MedicalInfo();this.EnrollmentDetails.Prescriptions = []; }
	
	}
	catch
	{
	}
}
SaveInjectableMedicineDetails(event:any) { if (this.vs.ValidateSections([this.InjectableMedicineInfoGroup?.control])) { Sys.AddItemToArray<MedicineDetail>(this.InjectableMedicineDetails, this.InjectablePrescriptionDetails.MedicineDetails);
this.ShowInjectableMedicine=false; } }
SaveOralMedicineDetails(event:any) { if (this.vs.ValidateSections([this.OralMedicineInfoGroup?.control])) { Sys.AddItemToArray<MedicineDetail>(this.OralMedicineDetails, this.OralPrescriptionDetails.MedicineDetails);
this.ShowOralMedicine=false;; } }
SaveSupportMedicineDetails(event:any) { if (this.vs.ValidateSections([this.SupportMedicineInfoGroup?.control])) { Sys.AddItemToArray<MedicineDetail>(this.SupportMedicineDetails, this.DrugsDetails.MedicineDetails);
this.ShowSupportMedicine=false; } }
async SubmitForm(event:any) { let IsPrescriptionExists:boolean = false;let EnrollmentActivityResponse=new HttpResponseMessage();if (this.vs.ValidateSections([this.PatientInfoGroup?.control])) { IsPrescriptionExists= this.ValidatePrescription();if (IsPrescriptionExists) { this.us.ClearFormDirty(this.OncologyFormForm);Sys.Clear<PrescriptionModel>(this.EnrollmentDetails.Prescriptions);
this.EnrollmentDetails.State=this.SelectedState;
;if (this.OralPrescriptionDetails.Refill!=null && this.OralPrescriptionDetails.MedicineDetails != null) { Sys.AddItemToArray<PrescriptionModel>(this.OralPrescriptionDetails, this.EnrollmentDetails.Prescriptions);; }if (this.InjectablePrescriptionDetails.Refill!=null && this.InjectablePrescriptionDetails.MedicineDetails != null) { Sys.AddItemToArray<PrescriptionModel>(this.InjectablePrescriptionDetails, this.EnrollmentDetails.Prescriptions);; }if (this.DrugsDetails.Refill!=null && this.DrugsDetails.MedicineDetails != null) { Sys.AddItemToArray<PrescriptionModel>(this.DrugsDetails, this.EnrollmentDetails.Prescriptions);; }let EnrollmentActivity= this.apiResponse.handle(<any>this.apiServc.AddEnrollment('enrollments',{},JSON.stringify(this.EnrollmentDetails)));EnrollmentActivityResponse=await EnrollmentActivity;if (EnrollmentActivityResponse.StatusCode==200 && Sys.IsNullOrEmpty(EnrollmentActivityResponse.Content.ErrorMessage)) { this.router.navigate(['SubmissionSuccess'],{ queryParams: { enrollmentId:EnrollmentActivityResponse.Content.Id } , queryParamsHandling: '' } ); }else{ this.InvalidAddressClass= Sys.IfElse(EnrollmentActivityResponse.StatusCode==200, "invalid-address","");this.us.Show(EnrollmentActivityResponse.Content.ErrorMessage,'error'); } } } }
ValidatePrescription(): boolean {    let valid: boolean = true ; if ((this.OralPrescriptionDetails.MedicineDetails == null && this.InjectablePrescriptionDetails.MedicineDetails == null && this.DrugsDetails.MedicineDetails == null) ||(this.OralPrescriptionDetails.MedicineDetails != null && this.OralPrescriptionDetails.MedicineDetails.length == 0) && (this.InjectablePrescriptionDetails.MedicineDetails!=null && this.InjectablePrescriptionDetails.MedicineDetails.length == 0) && (this.DrugsDetails.MedicineDetails != null &&this.DrugsDetails.MedicineDetails.length == 0)) { valid=false;this.us.Show("Please provide Prescription details",'error'); }else{ if (this.OralPrescriptionDetails.MedicineDetails != null && this.OralPrescriptionDetails.MedicineDetails.length > 0) { if (Sys.IsNullOrEmpty(this.OralPrescriptionDetails.Refill) || Sys.IsNullOrEmpty(this.OralPrescriptionDetails.Authorization)) { valid=false;this.us.Show("Please provide Oral Oncolytics prescription details",'error'); } }if (this.InjectablePrescriptionDetails.MedicineDetails != null && this.InjectablePrescriptionDetails.MedicineDetails.length > 0) { if (Sys.IsNullOrEmpty(this.InjectablePrescriptionDetails.Refill) || Sys.IsNullOrEmpty(this.InjectablePrescriptionDetails.Authorization)) { valid=false;this.us.Show("Please provide Injectable Oncolytics prescription details",'error'); } }if (this.DrugsDetails.MedicineDetails != null && this.DrugsDetails.MedicineDetails.length > 0) { if (Sys.IsNullOrEmpty(this.DrugsDetails.Refill) || Sys.IsNullOrEmpty(this.DrugsDetails.Authorization)) { valid=false;this.us.Show("Please provide Support Drugs prescription details",'error'); } } } return valid; }
  
  
  ngOnDestroy(){
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.intervalIds.forEach(intervalId => {
        clearInterval(intervalId)
        })
  }
  ngAfterViewChecked() {
    this.cdr.detectChanges()
  }
}
